import authentication from "@irati/auth";
import { getActiveProducts } from "@irati/products/utils/products";
import businessService from "@irati/identity/services/business";
import { perkbox } from "@irati/ui/src/global/colors";
import vitallyScript, { importVitally, VITALLY_TOKEN } from "./script";
import { CompanySize } from "../enums";
var getProducts = function () {
    return getActiveProducts().map(function (item) { return item.product; });
};
var getCompanySize = function (userTotal) {
    switch (true) {
        case userTotal < 50:
            return CompanySize.SME;
        case userTotal < 250:
            return CompanySize.MID_MARKET;
        default:
            return CompanySize.CORPORATE;
    }
};
var load = null;
var setUp = function () {
    var user = authentication.user();
    var _a = authentication.userTenant(), uuid = _a.uuid, public_name = _a.public_name, subdomain = _a.subdomain;
    var locale = authentication.userLocale();
    load = importVitally().then(function () {
        if (!window.Vitally) {
            return null;
        }
        vitallyScript();
        window.Vitally.init(VITALLY_TOKEN);
        businessService.userCount(uuid).then(function (userTotal) {
            window.Vitally.account({
                accountId: uuid,
                traits: {
                    name: public_name,
                    subDomain: subdomain,
                    tenantLocale: locale,
                    products: getProducts(),
                    numberOfUsers: userTotal,
                    companySize: getCompanySize(userTotal)
                }
            });
        });
        window.Vitally.user({
            userId: user.uuid,
            accountId: uuid,
            traits: {
                userId: user.uuid,
                createdAt: user.createdAt
            }
        });
    });
};
var showSurvey = function (formatMessage) {
    if (!load)
        setUp();
    load.then(function () {
        window.Vitally.nps("survey", {
            productName: "Perkbox",
            primaryColor: "" + perkbox.blue,
            npsQuestion: formatMessage({ id: "platform.Vitally.npsQuestion" }),
            followUpTitle: formatMessage({ id: "platform.Vitally.followUpTitle" }),
            followUpSubtitle: formatMessage({ id: "platform.Vitally.followUpSubtitle" }),
            thanksTitle: formatMessage({ id: "platform.Vitally.thanksTitle" }),
            thanksSubtitle: formatMessage({ id: "platform.Vitally.thanksSubtitle" }),
            minLabel: formatMessage({ id: "platform.Vitally.minLabel" }),
            maxLabel: formatMessage({ id: "platform.Vitally.maxLabel" }),
            placeholderText: formatMessage({ id: "platform.Vitally.placeholderText" }),
            submitText: formatMessage({ id: "platform.Vitally.submitText" }),
            dismissText: formatMessage({ id: "platform.Vitally.dismissText" })
        });
    });
};
export default { showSurvey: showSurvey };
